import get from "lodash/get";
import { isGlobalFeatureEnabled } from "./FeatureHelper";
import {
  getHelpCenterAuthUrl,
  getMexHelpCenterUrl,
  HELP_CENTER_URL_STAGING,
  HELP_CENTER_URL_PRODUCTION,
} from "./index";
import {
  TROY_SIDE_BAR_NAVIGATION,
  HC_HANDOVER_READY,
  SOURCE_HANDOVER_JWT,
  HC_HANDOVER_COMPLETE,
  HC_HANDOVER_START,
  HC_HANDOVER_SUCCESS,
  HC_HANDOVER_FAILED,
} from "../constants";
import { sessionPause } from "../middleware/session-middleware.js";

const TIMEOUT_DURATION = 5000;
const SESSION_DURATION = 45 * 60000;
const IFRAME_NAME = "helpcenter_aho"; // aho: auth handover
let handOverInProgress = false;

export const openHelpCenter = (trackEvent) => {
  const enabled = isGlobalFeatureEnabled("enableHelpCenterTokenHandover");
  if (!enabled) return openMexHelpCenter();
  if (handOverInProgress) return;

  handOverInProgress = true;
  trackEvent(TROY_SIDE_BAR_NAVIGATION, HC_HANDOVER_START);
  helpCenterJwtHandover()
    .then(() => {
      trackEvent(TROY_SIDE_BAR_NAVIGATION, HC_HANDOVER_SUCCESS);
      sessionPause(SESSION_DURATION);
    })
    .catch((error) => {
      trackEvent(TROY_SIDE_BAR_NAVIGATION, HC_HANDOVER_FAILED, error);
    })
    .finally(() => {
      openMexHelpCenter();
      handOverInProgress = false;
    });
};

const openMexHelpCenter = () => {
  const url = getMexHelpCenterUrl();
  window.open(url, "_blank");
};

const createHelpCenterIframe = () => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.name = IFRAME_NAME;
  iframe.src = getHelpCenterAuthUrl();
  document.body.appendChild(iframe);
};

const removeHelpCenterIframe = () => {
  const iframes = document.getElementsByName(IFRAME_NAME);
  iframes.forEach((node) => document.body.removeChild(node));
};

const isOriginVerified = (origin) =>
  [HELP_CENTER_URL_STAGING, HELP_CENTER_URL_PRODUCTION].includes(origin);

const postJWT = (event, token) => {
  // To use another way of getting JWT when its no longer stored in LS
  const jwt = token || localStorage.getItem("JWT");
  event.source.postMessage(
    {
      authMessageType: SOURCE_HANDOVER_JWT,
      jwt,
    },
    event.origin
  );
};

export const helpCenterJwtHandover = (jwt) =>
  new Promise((resolve, reject) => {
    const timeOut = setTimeout(() => {
      removeHelpCenterIframe();
      window.removeEventListener("message", eventListener);
      reject("timeout");
    }, TIMEOUT_DURATION);

    const eventListener = (event) => {
      if (!isOriginVerified(event.origin)) return;
      const authMessageType = get(event, ["data", "authMessageType"]);

      if (authMessageType === HC_HANDOVER_READY) {
        postJWT(event, jwt);
      }

      if (authMessageType === HC_HANDOVER_COMPLETE) {
        removeHelpCenterIframe();
        window.removeEventListener("message", eventListener);
        clearTimeout(timeOut);
        resolve();
      }
    };

    window.addEventListener("message", eventListener);
    createHelpCenterIframe();
  });
